import React from "react";
import { useLocation } from "react-router-dom";
import BankTransactionErrorCard from "@/components/ui/bankPayment/BankTransactionErrorCard";
import { BankPaymentError } from "@/types/bank-payment";

const PaymentFailedPage: React.FC = () => {
  const location = useLocation();

  // Get error data from navigation state or use default error
  const errorData = location.state?.error as BankPaymentError;

  const error: BankPaymentError = errorData || {
    error: true,
    title: "Payment Failed",
    message: "An unexpected error occurred while processing your payment",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto">
        <BankTransactionErrorCard
          title={error.title}
          message={error.message}
        />
      </div>
    </div>
  );
};

export default PaymentFailedPage;
